import HttpCliente from '../HttpCliente';

/**
 * GET method - Obtiene la lista de usuarios
 * @param {Function} setUsers función para establecer la lista de usuarios
 * @param {Function} setError función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const getUsers = (setUsers, setError) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get("/Usuario", {
            headers: {
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setUsers(response.data);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setError(error.response.data.message);
                reject(error.response.data.message);
            } else {
                setError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};

/**
 * GET method - Obtiene un usuario por ID
 * @param {string} userId - ID del usuario
 * @param {Function} onSuccess - Función callback en caso de éxito
 * @param {Function} onError - Función callback en caso de error
 * @return {Promise} Promesa de obtención
 */
export const getUserById = (userId, onSuccess, onError) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/Usuario/${userId}`, {
            headers: {
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                if (onSuccess) onSuccess(response);
                resolve(response.data);
            } else {
                if (onError) onError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            if (onError) onError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * POST method - Registra un nuevo usuario
 * @param {Object} newUser - Objeto que contiene los datos del usuario a registrar
 * @param {Function} setRegisterError - Función para establecer el estado de error
 * @return {Promise} Promesa de obtención
 */
export const createUser = (newUser, setRegisterError) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post("/Usuario", newUser, {
            headers: {
                'accept': '*/*',
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 201) {
                resolve(response.data);
            } else {
                setRegisterError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            if (error.response && error.response.data) {
                setRegisterError(error.response.data.message);
                reject(error.response.data.message);
            } else {
                setRegisterError("Error de conexión");
                reject("Error de conexión");
            }
        });
    });
};

/**
 * PUT method - Actualiza un usuario existente
 * @param {string} userId - ID del usuario a actualizar
 * @param {Object} updatedUser - Objeto que contiene los datos actualizados del usuario
 * @param {Function} onSuccess - Función callback en caso de éxito
 * @param {Function} onError - Función callback en caso de error
 * @return {Promise} Promesa de obtención
 */
export const updateUser = (userId, updatedUser, onSuccess, onError) => {
    return new Promise((resolve, reject) => {
        HttpCliente.put(`/Usuario/${userId}`, updatedUser, {
            headers: {
                'accept': '*/*',
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 204 || response.status === 200) {
                if (onSuccess) onSuccess(response);
                resolve(response.data);
            } else {
                if (onError) onError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            if (onError) onError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * POST method - Cambiar contraseña del usuario
 * @param {string} userId - ID del usuario
 * @param {Object} passwordData - Objeto con passwordActual y nuevaPassword
 * @param {Function} onSuccess - Función callback en caso de éxito
 * @param {Function} onError - Función callback en caso de error
 * @return {Promise} Promesa de obtención
 */
export const changePassword = (userId, passwordData, onSuccess, onError) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post(`/Usuario/cambiar-contraseña/${userId}`, passwordData, {
            headers: {
                'accept': '*/*',
                'Content-Type': 'application/json'
            }
        })
        .then(response => {
            if (response.status === 200) {
                if (onSuccess) onSuccess(response);
                resolve(response.data);
            } else {
                if (onError) onError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error de conexión";
            if (onError) onError(errorMessage);
            reject(errorMessage);
        });
    });
};